// Базовые секции
const BASE_WHY_PERFECT = {
    title: 'Видеопоздравление от ИИ-звезды',
    titleHighlight: 'идеально подходит,',
    reasons: [
        'Хочешь оригинально поздравить, но не знаешь как?',
        'Живые звезды стоят очень дорого и не отвечают в ЛС?',
        'У тебя мало времени, нужно срочно поздравить и произвести вау-эффект?'
    ]
};

const BASE_FIVE_REASONS = [
    {title: 'Эмоции бесценны', text: 'А видео с озвучкой стоит всего 890 руб.'},
    {title: 'Время не ждет', text: 'Получи готовое видео за 5 минут'},
    {title: 'Вау-эффект', text: 'Ваше видео будут пересылать друзьям'},
    {title: 'Звезды с неба падают', text: 'Выбери звезду на свой вкус от Путина до Маска'},
    {title: '100% гарантия возврата', text: 'Вернем деньги, если ИИ-звезда начудит...'}
];

const BASE_OCCASIONS = [
    {id: 'birthday', name: 'День рождения', icon: '🎂'},
    {id: 'jubilee', name: 'Юбилей', icon: '🎊'},
    {id: 'wedding', name: 'Свадьба', icon: '💍'},
    {id: 'promotion', name: 'Повышение', icon: '🚀'},
    {id: 'graduation', name: 'Выпускной', icon: '🎓'},
    {id: 'retirement', name: 'Выход на пенсию', icon: '🏖️'},
    {id: 'anniversary', name: 'Годовщина', icon: '💑'},
    {id: 'custom', name: 'Своё', icon: '💬'}
];

// Конфиг главной страницы
const HOME_CONFIG = {
    title: 'Видеопоздравление от ИИ-звезды',
    description: 'Создай видеопоздравление от ИИ-звезды за 3 минуты',
    hero: {
        title: 'Создай видеопоздравление',
        titleHighlight: 'от ИИ-звезды',
        features: ['890 руб. видео с озвучкой', 'готовое видео за 3 минуты']
    },
    occasions: BASE_OCCASIONS,
    whyPerfect: BASE_WHY_PERFECT,
    fiveReasons: BASE_FIVE_REASONS,
};

export function getPageConfig() {
    return HOME_CONFIG;
}
